/* tslint:disable */
import {
  ServiceCharterGroup
} from '../index';

declare var Object: any;
export interface ServiceCharterGroupingInterface {
  "name": string;
  "id"?: number;
  "institution_id"?: number;
  services?: ServiceCharterGroup[];
}

export class ServiceCharterGrouping implements ServiceCharterGroupingInterface {
  "name": string;
  "id": number;
  "institution_id": number;
  services: ServiceCharterGroup[];
  constructor(data?: ServiceCharterGroupingInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ServiceCharterGrouping`.
   */
  public static getModelName() {
    return "ServiceCharterGrouping";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ServiceCharterGrouping for dynamic purposes.
  **/
  public static factory(data: ServiceCharterGroupingInterface): ServiceCharterGrouping{
    return new ServiceCharterGrouping(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ServiceCharterGrouping',
      plural: 'ServiceCharterGroupings',
      path: 'ServiceCharterGroupings',
      properties: {
        "name": {
          name: 'name',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "institution_id": {
          name: 'institution_id',
          type: 'number'
        },
      },
      relations: {
        services: {
          name: 'services',
          type: 'ServiceCharterGroup[]',
          model: 'ServiceCharterGroup'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/theme/services/sdk/models/ServiceCharterGrouping.ts